export const definedTranslation = {
  title: {
    id: 'collections-block-title',
    defaultMessage: 'Featured collections',
  },
  button: {
    id: 'collections-block-all-button',
    defaultMessage: 'See All',
  },
};
